import { BehaviorParameters } from 'rangeConfig/@types';
import { FrameTopComponent } from '@inter-ikea-storageone/range';

const addTop = ({ coreApi, props }: BehaviorParameters) => {
  const frame = coreApi.entities.findSelectedEntity();
  if (frame) {
    frame.addComponent(new FrameTopComponent());
    coreApi.products.addToTarget(props.coreProductId, frame);
  }
};

export default addTop;
